import { useTranslation } from 'react-i18next'

import { ErrorBox } from 'components/Box'
import { GoogleAdManagerConnection } from 'features/globalSetup/pages/GoogleAdManagerConnectionPage/hooks/useGetConnection'
import { CONTAINER_SPACING } from 'providers/material-ui/theme/constants'
import { DATE_FORMAT, formatDate } from 'utils/date'
import { StatusBox } from '../../../../components/StatusBox'
import { useConfig } from './useConfig'

export const ConnectionStatus = ({
  errorMessage,
  status,
  updatedAt,
}: GoogleAdManagerConnection): JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.connectionStatus',
  })

  const { color, icon, tooltip } = useConfig(status)
  const isConnectionFailed = status === 'failed'

  return (
    <>
      <StatusBox
        color={color}
        icon={icon}
        message={t(`status.${status}`, {
          updatedAt: formatDate(updatedAt, DATE_FORMAT.WITH_TIME),
        })}
        tooltip={tooltip}
      />

      {isConnectionFailed && (
        <ErrorBox
          errorMessage={errorMessage}
          sx={{ mb: CONTAINER_SPACING }}
        />
      )}
    </>
  )
}
